import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import Button from '@fenderdigital/react-button';
import Link from '../../components/Link';
import MaxWidthLayout from '../../components/MaxWidthLayout';

const messages = defineMessages({
  notFoundGoToHome: {
    id: 'not-found.go-to-home',
    defaultMessage: 'Take me home',
  },
  notFoundDescription: {
    id: 'not-found.description',
    defaultMessage:
      'Sorry, that link may not be valid. You can check out the feed for some of the recommended stuff below.',
  },
});

function NotFound({ intl, title, staticContext }) {
  const { formatMessage } = intl;
  if (staticContext) {
    staticContext.status = 404;
    staticContext.notFound = true;
  }
  return (
    <MaxWidthLayout>
      <div className="pb4">
        <h1 className="b">{title}</h1>
        <p className="mb3">{formatMessage(messages.notFoundDescription)}</p>
        <Link to="/">
          <Button color="red" fontStyles="f8 futura-heavy ttu white" styles="bn br3 ph3 pv2">
            {formatMessage(messages.notFoundGoToHome)}
          </Button>
        </Link>
      </div>
    </MaxWidthLayout>
  );
}

NotFound.propTypes = {
  title: PropTypes.string,
  intl: intlShape.isRequired,
  staticContext: PropTypes.shape({
    status: PropTypes.number,
    notFound: PropTypes.bool,
  }).isRequired,
};

NotFound.defaultProps = {
  title: "We still haven't found what you're looking for...",
};

export default injectIntl(NotFound);
